<template>
  <div
    class="c-card"
    :class="{ '-arrow': arrow }"
  >
    <header
      class="header"
      v-if="icon || title || $slots.action"
      :class="{ '-actions': $slots.action }"
    >
      <c-title
        v-if="icon"
        class="title"
        :size="size"
        :icon="icon"
        icon-size="17"
      >
        {{ title }}
      </c-title>

      <c-title
        v-else
        class="title"
        :size="size"
      >
        {{ title }}
      </c-title>

      <div class="actions">
        <slot name="action" />
      </div>
    </header>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 4
    },
    arrow: Boolean,
    title: String,
    icon: String
  }
}
</script>

<style lang="scss">
@import '~@styles/convenia-components/reference.scss';

$c-card-triangle-width: 8px !default;
$c-card-button-size: 26px;

.c-card {
  & {
    @include elevation(1);
    border: 1px solid #e9eaee;
    background-color: white;
    border-radius: 3px;
    padding: 0;
  }

  &.-arrow {
    position: relative;

    @include medium-up {
      &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        top: $c-card-triangle-width * 2.5;
        left: -$c-card-triangle-width + 1px;
        transform: rotate(-45deg);
        border-bottom: $c-card-triangle-width solid transparent;
        border-right: $c-card-triangle-width solid transparent;
        border-top: $c-card-triangle-width solid white;
        border-left: $c-card-triangle-width solid white;
        z-index: 1;
        box-shadow: -3px -3px 4px 0px rgba(142, 146, 167, 0.05), -1px -1px 0px 0px #e9eaee;
      }
    }

  }

  & > .header {
    @extend %c-card-header;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
}

%c-card-header {
  & {
    padding-top: 18px;
    padding-right: 18px;
    padding-left: 18px;
  }

  & > .title {
    margin: 0;
    padding: 0;
    color: #9da2bb;
    font-weight: 400;

    .icon {
      fill: #daddec;
      position: relative;
      top: -1px;
    }
  }

  & > .actions { margin-left: auto; }

  & > .actions > * { margin-left: 8px; }

  &.-actions { padding-top: 12px; }
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CCard.vue